var __jsx = React.createElement;
import React, { Fragment, useEffect } from 'react';
import DatadogInit from '@spa/shared/components/Datadog';
import Eulerian from '@spa/shared/components/Scripts/eulerian';
import { GoogleTagManager, Termly } from '@spa/shared/components/Scripts';
import { initAmplitude } from '@spa/shared/hooks/tracking/services/amplitude/dataAmplitude';
var ScriptWrapper = function ScriptWrapper(_ref) {
  var eulerianProps = _ref.eulerianProps,
    datadogData = _ref.datadogData;
  useEffect(function () {
    initAmplitude(process.env.AMPLITUDE_API_KEY);
  }, []);
  return __jsx(Fragment, null, __jsx(Termly, null), __jsx(GoogleTagManager, null), __jsx(DatadogInit, {
    datadog: datadogData
  }), eulerianProps && process.env.EULERIAN_URL ? __jsx(Eulerian, eulerianProps) : null);
};
export default ScriptWrapper;